import React from 'react';
import logo from '../../images/essentia+web3.svg';

// const logoStyle = {
//   // width: "90%"
// }

const Logo = () => {
  return <img src={logo} alt="Essentia Logo" />;
};

export default Logo;

// style={ logoStyle }